export default "__VITE_PUBLIC_ASSET__bb3f3fe2__"